export const flattenDirty = (obj: any, prefix = ''): string[] =>
  Object.entries(obj).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;

    if (value === true) return [path];
    if (typeof value === 'object' && value !== null)
      return flattenDirty(value, path);

    return [];
  });
